import { BRAND } from '~environments/environment';
import { constants } from '../../../constants/constants';

// Resource Bundle Mock Response
import {royalResourceBundleMock} from './royal.mock';
import {celebrityResourceBundleMock} from './celebrity.mock';

export const resourceBundleManagerMock = () => {
  const brand = BRAND || 'royal';
  switch ( brand ) {
    case constants.BRANDS_NAMES.ROYAL:
      return royalResourceBundleMock;
    case constants.BRANDS_NAMES.CELEBRITY:
      return celebrityResourceBundleMock;
  }
}
